import { queryOptions } from '@tanstack/react-query';
import { PortalApiClient } from '../portalApiClient';

export const getMeQueryOptions = (portalApiClient: Pick<PortalApiClient, 'getMe'>) =>
  queryOptions({
    queryKey: ['me'] as const,
    queryFn: async () => await portalApiClient.getMe(),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
  });

export const getSubscriptionPlanQueryOptions = (portalApiClient: Pick<PortalApiClient, 'getSubscriptionPlan'>) =>
  queryOptions({
    queryKey: ['current'] as const,
    queryFn: async () => await portalApiClient.getSubscriptionPlan(),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
  });

export const getProjectQueryOptions = (portalApiClient: Pick<PortalApiClient, 'getProject'>, projectId: number) =>
  queryOptions({
    queryKey: ['project', projectId] as const,
    queryFn: async () => await portalApiClient.getProject({ projectId }),
    refetchOnWindowFocus: false,
  });

export const projectQuizesQueryKey = (projectId: number) => ['projectQuizes', projectId] as const;

export const getProjectQuizesQueryOptions = (
  portalApiClient: Pick<PortalApiClient, 'getProjectQuizes'>,
  projectId: number
) =>
  queryOptions({
    queryKey: projectQuizesQueryKey(projectId),
    queryFn: async () => await portalApiClient.getProjectQuizes({ projectId }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
